import React from 'react';
import { Box, Drawer } from '@metarouter-private/mr-mui';
import { useDrawerContext } from 'app/shared/contexts/drawer';
import TRANSFORMATION_DRAWERS from './TRANSFORMATION_DRAWERS';
import PipelineEventSplitDrawerContent from './PipelineEventSplitDrawerContent';
import PipelineFiltersDrawerContent from './PipelineFiltersDrawerContent';
import PipelineTransformationsDrawerContent from './PipelineTransformationsDrawerContent';

export default function PipelineTransformationsDrawer() {
  const {
    drawer: { isOpen, onClose, data },
  } = useDrawerContext();

  return (
    <Drawer onClose={onClose} open={isOpen} anchor="right" width="60%" data-test-id="pipeline-configuration-drawer">
      <Box p={2}>
        {data?.drawer === TRANSFORMATION_DRAWERS.PIPELINE_FILTERS && (
          <PipelineFiltersDrawerContent filters={data.filter} />
        )}
        {data?.drawer === TRANSFORMATION_DRAWERS.PIPELINE_TRANSFORMS && (
          <PipelineTransformationsDrawerContent transform={data.transform} />
        )}
        {data?.drawer === TRANSFORMATION_DRAWERS.PIPELINE_EVENT_SPLIT && (
          <PipelineEventSplitDrawerContent eventSplit={data.eventSplit} />
        )}
      </Box>
    </Drawer>
  );
}
